<div class="dashboard-notification" (click)="navigateToDetails()" *ngIf="!isNotificationCancelledFlag">
    <div class="card-header row justify-content-between">
        <div class="col-auto">
            <p class="notification-date m-0">{{ strings.weekday }} {{ strings.startDateTime }}</p>
        </div>
        <div class="col-auto">
            <div class="row">
                <div *ngIf="notification.isEscalated" class="col-auto card-header-icon ps-2">
                    <fa-icon [icon]="faExclamationTriangle" size="lg" class="red"></fa-icon>
                </div>
                <div *ngIf="notification.isCancelled" class="col-auto card-header-icon ps-0">
                    <fa-icon [icon]="faBan" size="lg" class="red"></fa-icon>
                </div>
            </div>
        </div>
    </div>

    <p class="notification-date m-0" *ngIf="isMultiDayNotification(notification)">
        {{ strings.multiDayWeekday }} {{ strings.multiDayEndDateTime }}
    </p>

    <p class="name m-0">{{ strings.name }}</p>
    <p class="notification-type m-0">{{ strings.notificationType }}</p>
    <p class="m-0" *ngIf="displayContactName">{{ strings.contactName }}</p>
    <p class="tidnr m-0" *ngIf="strings.tidnr">
        {{ strings.tidnr }}
        <span>{{ strings.productName }}</span>
    </p>
    <p
        class="m-0"
        *ngIf="strings.affectedEquipment.length > 0"
        [ngClass]="{
            'text-clipped': !(
                noOfOrderedMaterials ||
                strings.formsAvailable.length > 0 ||
                noOfParticipants ||
                strings.clarifyText.length > 0
            ),
        }"
    >
        <span translate="CONFIRMATION_EQUIPMENT_AFFECTED_EQUIPMENT_LABEL"></span>: {{ strings.affectedEquipment }}
    </p>
    <p
        class="m-0"
        [ngClass]="{
            'text-clipped': !(noOfOrderedMaterials || strings.formsAvailable.length > 0 || noOfParticipants),
        }"
        *ngIf="strings.clarifyText"
        [innerHTML]="strings.clarifyText | paceUrl"
    ></p>
    <p
        *ngIf="notification.csmlTrackerUrl && noOfOrderedMaterials"
        class="additional-info m-0"
        paceCoreLink
        (click)="$event.stopPropagation()"
    >
        <a class="pace-link" href="{{ notification.csmlTrackerUrl }}" target="_blank" translate="TRACK_ALL_ORDERS"></a>
    </p>
    <div class="card-footer row justify-content-between">
        <div class="col-auto align-self-end">
            <fa-icon [icon]="effectCodeIcon" size="lg" [class]="effectCodeIconColorClass"></fa-icon>
        </div>
        <div class="col-auto card-footer-right">
            <div class="row justify-content-end align-items-center">
                <div class="col-auto card-footer-icon pe-0 ps-2" *ngIf="noOfParticipants">
                    <span class="pe-1">{{ noOfParticipants }}</span>
                    <fa-icon [icon]="faParticipants"></fa-icon>
                </div>
                <div class="col-auto card-footer-icon pe-0 ps-2" *ngIf="noOfOrderedMaterials">
                    <span class="pe-1">{{ noOfOrderedMaterials }}</span>
                    <fa-icon [icon]="faBox" size="lg"></fa-icon>
                </div>
                <div class="col-auto card-footer-icon pe-0 ps-2" *ngIf="notification.isRemoteSupport">
                    <fa-icon [icon]="faPhone" size="lg"></fa-icon>
                </div>
                <div class="col-auto card-footer-icon pe-0 ps-2" *ngIf="strings.formsAvailable.length > 0">
                    <fa-icon [icon]="faFileInvoice" size="lg"></fa-icon>
                </div>
                <div class="col-auto card-footer-btn ps-2">
                    <pace-notification-status-badge
                        [notification]="notification"
                        [notificationStatus]="notificationService.notificationStatusSignal()"
                        [showEscalatedIcon]="false"
                        [showCancelledIcon]="false"
                    ></pace-notification-status-badge>
                </div>
            </div>
        </div>
    </div>
</div>
